export default {"src":"/_next/static/media/hotspot-icon.10f53097.svg","height":87,"width":80};